var map = {
	"./blue.png": "3ad8",
	"./green.png": "500e",
	"./grey.png": "3c11",
	"./orange.png": "8aff",
	"./pink.png": "4611",
	"./purple.png": "b013",
	"./red.png": "1a8c2",
	"./turquoise.png": "040b",
	"./violet.png": "18ee",
	"./yellow.png": "b416"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b30f";